class TabSwitch extends HTMLElement {
    /**
     * Switch tag
     * @type {Element}
     */
    tagList;

    /**
     * Switch content 
     * 
     *  @type {Element}
     */
    tagContent;

    constructor() {
        super();

        this.tagList = this.querySelectorAll('.tab_item')
        this.tagContent = this.querySelectorAll('.content_item')
        this.tagSwitch()
    }
    tagSwitch() {
        let that = this
        this.tagList.forEach((element, index) => {
            element.addEventListener('click', function (e) {
                element.classList.add('active')
                $(element).siblings().removeClass('active')
                that.tagContent.forEach((element2, index2) => {
                    element2.style.display = "none"
                })
                that.tagContent[index].style.display = "block"
            })
        });
    }





}

// Use custom element tag name without a dot
customElements.define('tab-swtich', TabSwitch);


document.addEventListener('DOMContentLoaded', function () {
    $('.content_item .faq_ask').click(function () {
        $(this).next('.faq_box').slideToggle(600);
        $(this).toggleClass('active');
    });
});
